import { gridTpl } from '../../../../../common/grid/grid.controller';

export const administrationVendorsGrid = {
    bindings: {
        onSelect: '&'
    },
    controller: 'AdministrationVendorsGridController',
    ...gridTpl
};
